import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import lo from 'lodash';
import DataTable from 'components/organisms/DataTable/index';
import ButtonReg from 'components/atoms/Buttons/Button';
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter';
import { EditFormater } from 'components/molecules/TableFormatters/editFormatter';

export class ActualLoadingCoalTemperatureForm extends Component {
  average = (arr) => (arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0)
  onChange(val, row, field, rowIndex) {
    const { form: { coalTemperature: { coalTemperatures } }, onChange } = this.props
    const { form: { coalTemperature } } = this.props
    const newData = coalTemperatures.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : val
    } : d)
    coalTemperature.coalTemperatures = newData
    if (field === 'coalTemperature') {
      const temperature = coalTemperature.coalTemperatures.map((d) => Number(d.coalTemperature))
      coalTemperature.averageTemperature = Number(this.average(temperature)).toFixed(2)
    }
    onChange('coalTemperature', coalTemperature)
  }

  add() {
    const { form: { coalTemperature: { coalTemperatures } }, onChange } = this.props
    const { form: { coalTemperature } } = this.props
    const newCoalTemperature = { no: coalTemperatures.length + 1, coalTemperature: 0}
    const newData = [...coalTemperatures, lo.cloneDeep(newCoalTemperature)]
    coalTemperature.coalTemperatures = newData
    onChange('coalTemperature', coalTemperature)
  }

  delete(row, rowIndex) {
    const { form: { coalTemperature: { coalTemperatures } }, onChange } = this.props
    const { form: { coalTemperature } } = this.props
    const newData = coalTemperatures.filter((d,i) => i !== rowIndex)
    coalTemperature.coalTemperatures = newData.map((d,i) => ({ ...d, no: i+1 }))
    const temperature = coalTemperature.coalTemperatures.map((d) => Number(d.coalTemperature))
    coalTemperature.averageTemperature = Number(this.average(temperature)).toFixed(2)
    onChange('coalTemperature', coalTemperature)
  }

  render() {
    const { viewState: { isMobileView }, theme, form: { coalTemperature } } = this.props

    const config = [
      {
        dataField: 'no',
        text: 'No',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          readOnly: true,
          type: 'number',
          field: 'no',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        footer: 'Average',
        footerStyle: {
          color: theme.mocaGreen
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'coalTemperature',
        text: 'Coal Temp(C)',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter coal temperature',
          type: 'number',
          field: 'coalTemperature',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        footer: 'Average',
        footerFormatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{coalTemperature.averageTemperature || 0}</div>
        },
        footerStyle: {
          color: theme.mocaGreen
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { minWidth: 100 },
        formatter: actionFormatter,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowDel: true,
          del: (row, rowIndex) => this.delete.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true
      },
    ]

    return (
        <RoundedWrapper>
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Coal Temperature
              </Label>
            </HeadContainer>
              <LevelRowContainer>
                <DataTable
                  leftSlot={
                    <ButtonReg
                      btnTxt={'Add'}
                      onClick={() => this.add()}
                      width={'78px'}
                    />
                  }
                  allowSearch={false}
                  rightSlotAlt={true}
                  defaultSize={100}
                  isMobile={isMobileView}
                  dataList={coalTemperature.coalTemperatures || []}
                  columnConfig={config}
                />
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingCoalTemperatureForm)
  )
);
